<!-- @format -->
<template>
	<el-container
		class="pc-layout-main"
		:class="[
			{ 'pc-layout-header-hide': !globalStore.visible.pcLayoutHeader },
			{ 'pc-layout-menu-closed': !appStore.sidebar.opened },
			{ 'pc-layout-menu-hide': !globalStore.visible.pcLayoutMenu },
		]"
	>
		<el-header v-if="globalStore.visible.pcLayoutHeader" class="pc-layout-main-el-header">
			<pcp-header2 :name="globalStore.curSystemAlias" />
		</el-header>
		<div v-if="routerStore.linkUrl" class="pc-layout-main-el-content">
			<inner-link2 />
		</div>
		<el-container v-else class="pc-layout-main-el-content">
			<el-aside v-if="globalStore.visible.pcLayoutMenu" class="pc-layout-main-el-aside">
				<pcp-side-bar v-model="menuStore.displayMenus" :route="route" :show-only-children="false" />
			</el-aside>
			<div class="pc-layout-main-el-container">
				<router-view #="{ Component }">
					<component :is="Component" :key="route.name" />
				</router-view>
			</div>
		</el-container>
	</el-container>
</template>

<script lang="ts" setup>
	import { useGlobalStoreWithOut } from '@power/runtime-vue3';
	import { useRouterStoreWithOut } from '@/store/modules/router';
	import { useAppStoreWithOut } from '@/store/modules/app';
	import InnerLink2 from '@/p-layout/components/inner-link/index2.vue';
	import { PcpSideBar, PcpHeader2 } from '@/p-components';
	import { useMenuStore } from '@/store/modules/menu';
	const routerStore = useRouterStoreWithOut();
	const globalStore = useGlobalStoreWithOut();
	const menuStore = useMenuStore();
	const appStore = useAppStoreWithOut();
	const route = useRoute();
</script>

<style scoped lang="scss"></style>
